export const GET_TERMS_AND_CONDITIONS = "GET_TERMS_AND_CONDITIONS";
export const SET_TERMS_AND_CONDITIONS = "SET_TERMS_AND_CONDITIONS";